import {
  Component,
  OnInit,
  AfterViewInit,
  Inject,
  Output,
  EventEmitter,
} from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { DOCUMENT } from '@angular/common';
import { DbService } from '../core/services/db.service';
import { AuthService } from '../core/services/auth.service';
import { AlertService } from '../core/services/alert.service';
import { Notifications } from '../models/notifications.model';
import * as dayjs from 'dayjs';
import { map, Observable } from 'rxjs';

@Component({
  selector: 'app-layout',
  templateUrl: './layout.component.html',
  styleUrls: ['./layout.component.scss'],
})
export class LayoutComponent implements OnInit, AfterViewInit {
  configData;
  openSwitch = false;

  //TODO 사이드 메뉴 리스트 넣기
  menu = [
    {
      label: '대시보드',
      icon: 'bx-home',
      link: '/dashboard',
    },
    {
      label: '회원 관리',
      icon: 'bx-user',
      link: '/user-list',
    },
    {
      label: '요청 및 선물 관리',
      icon: 'bx-list-ul',
      subItems: [
        {
          label: '전환율 관리',
          link: '/conversion-management',
        },
        {
          label: '요청 및 선물 관리',
          link: '/request-gift-management',
        },
        {
          label: '처리 내역',
          link: '/process-history',
        },
      ],
    },
    {
      label: 'D.CHAIN 지급 관리',
      icon: 'bx-home',
      link: '/dpoint-management',
    },
    {
      label: '가맹점 관리',
      icon: 'bx-user',
      link: '/affiliated-store-management',
    },
    {
      label: '기타 관리',
      icon: 'bx-list-ul',
      subItems: [
        {
          label: '코인문구 포인트/명칭 관리',
          link: '/point-coin-name-management',
        },
        // {
        //   label: 'D.CHAIN 전환하기 문구 관리',
        //   link: '/text-manage',
        // },
        {
          label: '지갑 숨김처리 관리',
          link: '/hide-wallet',
        },
        {
          label: '관리자 계좌 정보/거래소 주소 관리',
          link: '/admin-information-management',
        },
        {
          label: '예치하기 안내문 관리',
          link: '/deposit-guide-management',
        },
      ],
    },
    {
      label: '팝업 관리',
      icon: 'bx-user',
      link: '/popup-management',
    },
    {
      label: '약관 관리',
      icon: 'bx-user',
      link: '/terms',
    },
  ];

  routerUrl: string;

  constructor(
    // private eventService: EventService,
    private router: Router,
    @Inject(DOCUMENT) private document: any,
    private db: DbService,
    private auth: AuthService,
    private alertService: AlertService
  ) {
    router.events.forEach((event) => {
      if (event instanceof NavigationEnd) {
        // this._activateMenuDropdown();
        this.routerUrl = event.url;
      }
    });
  }

  ngOnInit() {
    //사이드바 정의
    document.body.setAttribute('data-sidebar', 'dark');
    this.configData = {
      suppressScrollX: true,
      wheelSpeed: 0.3,
    };

    this.configData = {
      suppressScrollX: true,
      wheelSpeed: 0.3,
    };

    this.getNotifications();
  }

  @Output() settingsButtonClicked = new EventEmitter();
  @Output() mobileMenuButtonClicked = new EventEmitter();

  isCondensed = false;

  /**
   * on settings button clicked from topbar
   */
  onSettingsButtonClicked() {
    document.body.classList.toggle('right-bar-enabled');
    this.onSettingsButtonClicked();
  }

  /**
   * On mobile toggle button clicked
   */
  onToggleMobileMenu() {
    this.isCondensed = !this.isCondensed;
    document.body.classList.toggle('sidebar-enable');
    document.body.classList.toggle('vertical-collpsed');

    if (window.screen.width <= 768) {
      document.body.classList.remove('vertical-collpsed');
    }
  }

  ngAfterViewInit() {
    // this._activateMenuDropdown();
  }

  toggleMenu(event) {
    event.currentTarget.nextElementSibling.classList.toggle('mm-show');
  }

  scrollable() {
    document.body.setAttribute('data-layout-scrollable', 'true');
  }

  /**
   * Toggles the right sidebar
   */
  toggleRightSidebar() {
    this.settingsButtonClicked.emit();
  }

  /**
   * Toggle the menu bar when having mobile screen
   */
  toggleMobileMenu(event: any) {
    event.preventDefault();
    // this.mobileMenuButtonClicked.emit();
    this.onToggleMobileMenu();
  }

  /**
   * Logout the user
   */
  logout() {
    this.auth.logoutUser().then(() => {
      localStorage.clear();
      this.router.navigate(['/account/login']);
    });
  }

  public hide() {
    document.body.classList.remove('right-bar-enabled');
  }

  open(list, menu, mi) {
    const activeTag = document.querySelector<HTMLElement>('.active');
    if (activeTag) {
      activeTag.classList.remove('active');
    }
    if (list.openSwitch) {
      list.openSwitch = false;
    } else {
      list.openSwitch = true;
      menu.forEach((ele) => {
        if (ele != list && ele.openSwitch == true) {
          ele.openSwitch = false;
        }
      });

      if (list.subItems && list.subItems.length > 0) {
        for (let index = 0; index < list.subItems.length; index++) {
          const element = list.subItems[index];

          if (element.link == this.routerUrl) {
            const aTag = document.querySelector<HTMLElement>(
              `.atag${mi}${index}`
            );
            aTag.classList.add('active');
          }
        }
      }
    }
  }

  close(aTag: HTMLElement) {
    aTag.classList.add('active');
    this.menu.forEach((ele: any) => {
      ele.openSwitch = false;
    });
  }

  // 알람 내역 데이터
  notifications$: Observable<Notifications> | any;
  unReadLength: number = 0;
  getNotifications() {
    this.notifications$ = this.db
      .collection$(`notifications`, (ref) =>
        ref.where('uuid', '==', 'admin').orderBy('dateCreated', 'desc')
      )
      .pipe(
        map((notifications: Notifications[] | any) => {
          this.unReadLength = notifications.filter(
            (notification) => !notification.readSwitch
          ).length;
          return notifications;
        })
      );
  }

  // 알림내역 시간 표시
  displayedAt(dateCreated: string) {
    const milliSeconds = new Date().getTime() - dayjs(dateCreated).valueOf();
    const seconds = milliSeconds / 1000;

    if (seconds < 60) {
      return `방금 전`;
    }
    const minutes = seconds / 60;
    if (minutes < 60) {
      return `${Math.floor(minutes)}분 전`;
    }
    const hours = minutes / 60;
    if (hours < 24) {
      return `${Math.floor(hours)}시간 전`;
    }
    const days = hours / 24;
    if (days < 30) {
      return `${Math.floor(days)}일 전`;
    }
    const months = days / 30;
    if (months < 12) {
      return `${Math.floor(months)}개월 전`;
    }

    return dayjs(dateCreated).format('YY.MM.DD');
  }

  // 알림 [상세]
  async alarm(item: Notifications) {
    await this.db.updateAt(`notifications/${item.id}`, {
      readSwitch: true,
    });

    // 해당 페이지로 이동
    if (item.url === '/request-gift-management') {
      this.router.navigate(['/request-gift-management']);
    }
  }

  // 알림 [전체삭제]
  async alarmDelete() {
    const ok = await this.alertService.warningConfirm(
      '전체 삭제하시겠습니까?',
      '확인',
      '취소',
      '',
      'warning'
    );

    if (ok) {
      this.notifications$.forEach((notifications: Notifications[]) => {
        notifications.forEach((notification) => {
          this.db.delete(`notifications/${notification.id}`);
        });
      });
    }
  }
}
